export default "__VITE_ASSET__B5SUgt5g__"